import { useEffect } from 'react';
import { track } from './analytics';

export const UNKNOWN_DWELL_MS = 30_000;

type UnknownDwellAnalyticsInput = Readonly<{
  visible: boolean;
  layoutVersionKnown: boolean;
}>;

/**
 * H-4의 잔존 측정. 증거가 없는 결과가 같은 route에서 연속으로 보일 때만 30초를 센다.
 * 후보·좌석·공연·계정 값은 analytics payload에 넣지 않는다.
 */
export function useUnknownDwellAnalytics({ visible, layoutVersionKnown }: UnknownDwellAnalyticsInput): void {
  useEffect(() => {
    if (!visible) return undefined;

    const startedAt = Date.now();
    let dwellReached = false;
    track('evidence_unknown_shown', { layoutVersionKnown });
    const timer = window.setTimeout(() => {
      dwellReached = true;
      track('unknown_dwell_30s', { layoutVersionKnown });
    }, UNKNOWN_DWELL_MS);
    const onPagehide = () => {
      track('session_exit', {
        lastSurface: 'evidence_unknown',
        dwellBucket: dwellReached || Date.now() - startedAt >= UNKNOWN_DWELL_MS ? 'at_least_30s' : 'under_30s',
      });
    };
    window.addEventListener('pagehide', onPagehide);

    return () => {
      window.clearTimeout(timer);
      window.removeEventListener('pagehide', onPagehide);
    };
  }, [layoutVersionKnown, visible]);
}
